export const REDIRECTS = 'redirects/'
export const TOOLBAR = 'toolbar/'
export const TRADUZIONI = 'traduzioni/'
export const MENU = 'menu/'
